import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['milestone', 'progress'];

    connect() {
        if (!this.hasProgressTarget || this.milestoneTargets.length === 0) {
            return;
        }

        this.pathLengths = new Map();
        this.progressTargets.forEach((path) => {
            const length = path.getTotalLength();
            this.pathLengths.set(path, length);
            path.style.strokeDasharray = `${length}`;
        });
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.frameRequested = false;
        this.requestRender = this.requestRender.bind(this);
        this.render = this.render.bind(this);

        this.element.classList.add('is-path-ready');
        this.render();

        if (!this.reduceMotion) {
            window.addEventListener('scroll', this.requestRender, {passive: true});
            window.addEventListener('resize', this.requestRender);
        }
    }

    disconnect() {
        window.removeEventListener('scroll', this.requestRender);
        window.removeEventListener('resize', this.requestRender);
    }

    requestRender() {
        if (!this.frameRequested) {
            window.requestAnimationFrame(this.render);
            this.frameRequested = true;
        }
    }

    render() {
        const bounds = this.element.getBoundingClientRect();
        const travel = window.innerHeight * 0.78 - bounds.top;
        const distance = bounds.height + window.innerHeight * 0.48;
        const progress = this.reduceMotion ? 1 : Math.min(1, Math.max(0, travel / distance));

        this.pathLengths.forEach((length, path) => {
            path.style.strokeDashoffset = `${length * (1 - progress)}`;
        });
        this.milestoneTargets.forEach((milestone, index) => {
            const threshold = (index + 0.22) / (this.milestoneTargets.length + 0.18);
            milestone.classList.toggle('is-visible', progress >= threshold);
        });
        this.frameRequested = false;
    }
}
